module.exports = __webpack_public_path__ + "img/file-diff-fill.5c46cfd0.svg";